import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormBuilder, Validators } from '@angular/forms';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { fuseAnimations } from '../../../../../../../core/animations';
import { TranslationService } from '../../../../../../services/translation/translation.service';
import { SweetAlertService } from '../../../../../../services/sweet-alert/sweet-alert.service';
import { TypeEmployeeService } from '../../../../../../services/type-employee/type-employee.service';
import { ShiftService } from '../../../../../../services/shifts/shift.service';
import { JobTitleService } from '../../../../../../services/jobtitle/jobtitle.service';

import * as textMask from 'vanilla-text-mask/dist/vanillaTextMask.js';
import { PaymentConceptService } from '../../../../../../services/payment-concept/payment-concept.service';
import { Observable } from 'rxjs/Observable';
import { PaymentConcept } from '../../../../../../models/payment-concept/payment-concept';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../../../../../const/date-format';
import { CurriculumService } from '../../../../../../services/curricula/curriculum.service';
import { CourseYearsDataDto, CurriculumDataDto, SubjectDataDto } from '../../../../../../models/curricula/dto/curriculum-data';

@Component({
    selector: 'fuse-payment',
    templateUrl: './pending-subject.component.html',
    styleUrls: ['./pending-subject.component.scss'],
    providers: [
        {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ],
    animations: fuseAnimations
})
export class PendingSubjectComponent implements OnInit, AfterViewInit, OnDestroy {
    @BlockUI() blockUI: NgBlockUI;
    formGroup;

    
    curriculumFormControl;
    courseYearFormControl;
    subjectFormControl;
    minDate = new Date(1930, 0, 1);
    maxDate = new Date();

    public attrs = [];
    public typeEmployees = [];
    public jobTitles = [];
    public shifts = [];
    mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    maskedInputControllerDate;
    @ViewChild('date', {read: ViewContainerRef}) public date;
    public curriculums: CurriculumDataDto[];
    public courseYears: CourseYearsDataDto[];
    public subjects: SubjectDataDto[];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<PendingSubjectComponent>,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private fb: FormBuilder,
        public typeEmployeeService: TypeEmployeeService,
        public shiftService: ShiftService,
        public paymentConceptService: PaymentConceptService,
        public curriculumService: CurriculumService,
    ) {
        console.log('FuseAddStudentComponent > data', data);
        this.initializeFormControlValidators();
        if (this.data.mode === 'view') {
            this.disable();
        }
    }

    disable() {
        this.formGroup.get('curriculumFormControl').disable();
        this.formGroup.get('courseYearFormControl').disable();
        this.formGroup.get('subjectFormControl').disable();
    }

    initializeFormControlValidators() {
        this.formGroup = this.fb.group({
            curriculumFormControl: ['', [Validators.required]],
            courseYearFormControl: ['', [Validators.required]],
            subjectFormControl: ['', [Validators.required]],
        });
    }

    filterCurseYears() {
        // filtrar course years
        console.log(this.data.payment.CurriculumId);
        this.courseYears = this.curriculums.find(e => e.Id == this.data.payment.CurriculumId).CourseYears;
        console.log(this.courseYears);
    }

    filterSubjects() {
        // filtrar course years
        console.log(this.data.payment.CourseYearId);
        this.subjects = this.courseYears.find(e => e.Id == this.data.payment.CourseYearId).CourseYearSubjects;
        console.log(this.courseYears);
    }

    checkValidationErrors() {
        setTimeout(() => {
        }, 20);

        
    }

    ngAfterViewInit() {
        
    }

    ngOnDestroy() {
        
    }


    ngOnInit() {
        this.blockUI.start(this.translationService.loading);
        Observable.combineLatest(
            this.curriculumService.getAllYearSubjects()
        ).subscribe(([curriculums]) => {
            console.log(curriculums);
            this.curriculums = curriculums;
            this.blockUI.stop();
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    save() {
        this.dialogRef.close(this.data.payment);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/students/components/pending-subjects/pending-subject.component.ts